import React from 'react';
import BaseSimplePage from "../BaseSimplePage/BaseSimplePage";
import ArtistsItemForm from "./ArtistsItemForm";
import ArtistsItemBrowser from "./ArtistsItemBrowser";

const ArtistsPage = ({isAddSubMode}) => {

    return (
        <BaseSimplePage
            isAddSubMode={isAddSubMode}
            modeApiName1="artist"
            modeApiName2="artists"
            ItemFormComponent={ArtistsItemForm}
            ItemBrowserComponent={ArtistsItemBrowser}
        />
    );
};

export default ArtistsPage;